export const DELETEPROFILEPIC = "DELETEPROFILEPIC";
export const DELETEPROFILEPIC_ERROR = "DELETEPROFILEPIC_ERROR";
export const DELETEPROFILEPIC_HIDE_ERROR = "DELETEPROFILEPIC_HIDE_ERROR";
export const DELETEPROFILEPIC_START_LOADER = "DELETEPROFILEPIC_START_LOADER";
export const DELETEPROFILEPIC_STOP_LOADER = "DELETEPROFILEPIC_STOP_LOADER";
